import { ca } from '@cian/analytics';

export const trackAddMyHomeClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label: 'AddObject',
  });
};
